export async function createDefaultSettings(
    franchiseID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                franchiseId: franchiseID,
                types: [],
                data: {},
            }),
        };
        const data = await fetchGlobal(apiUrl, requestOptions);
        return data;
    } catch (e) {
        console.log(e);
    }
}
